import { createAsyncThunk } from "@reduxjs/toolkit";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { ApiError } from "@/shared/types";
import { handleError } from "@/shared/lib/helpers/utils";
import { LC_AUTH_TOKEN } from "@/shared/const/storageKeys";

export const logout = createAsyncThunk<void, void, ThunkConfig<ApiError>>("auth/logout", async (_, thunkApi) => {
  const { rejectWithValue } = thunkApi;

  try {
    localStorage.removeItem(LC_AUTH_TOKEN);
  } catch (err) {
    return rejectWithValue(handleError(err));
  }
});
